// extracted by mini-css-extract-plugin
module.exports = {"component":"LoginScreen_component__8m3eL"};